document.addEventListener("DOMContentLoaded", function () {
  // Load jQuery from CDN (example)
  var script = document.createElement("script");
  script.src = "https://code.jquery.com/jquery-3.6.0.min.js"; // Replace with your jQuery version or local path
  script.onload = function () {
    // jQuery is now loaded, you can use it

    /*????,???
    jQuery('.ajax-spin-cart').click(async function (e) {
      e.preventDefault();
      await Shopify.addItemFromForm('add-item-form');
    });
  };
  document.head.appendChild(script);
  */

    // Create modal
    var modal = document.createElement("div");
    modal.id = "specModal";
    modal.classList.add("modal");
    modal.innerHTML = `
    <div class="modal-content">
      <h2 class="modal-title"></h2>
      <span class="close">&times;</span>
      <div class="modal-body"></div>
      <button type="submit" class="btn btn-style1 add-to-cart ajax-spin-cart" id="AddToCart" style=" position: fixed;
     bottom:0px; z-index: 999999999999999999999;width:full;left:0px;right:0px;">
         <span class="cart-title" id="AddToCartText">Add to Cart - <span class="add-to-cart-product-price1">$0.00</span></span>
        <span class="cart-loading animated infinite rotateOut">
          <i class="ion-load-a"></i>
        </span>
        <span class="cart-added">
          <i class="ion-android-done"></i>
        </span>
        <span class="cart-unavailable"></span>
        <div class="sp-validate-overlay" style="position: absolute; display: block; z-index: 100000; cursor: pointer; inset: 0px;"></div>
      </button>
    </div>
  `;
    document.body.appendChild(modal);

    var closeModalBtn = modal.querySelector(".close");
    var modalTitle = modal.querySelector(".modal-title");
    var modalBody = modal.querySelector(".modal-body");

    // Function to copy content to modal and show it
    function showModal(detailsElement) {
      var accordionContent = detailsElement.querySelector(
        ".accordion__content"
      ).innerHTML;
      var accordionTitle =
        detailsElement.querySelector(".accordion__title").innerText;
      var productPrice = document.getElementById("ProductPrice").innerText;
      document.querySelector(".add-to-cart-product-price1").innerText =
        productPrice;

      modalBody.innerHTML = accordionContent;
      modalTitle.innerText = accordionTitle;
      modal.style.display = "block";
      modal.querySelector(".mobile-cart-action").classList.remove("hidden");
    }

    // Handle details toggle event on mobile
    var detailsElements = document.querySelectorAll(
      ".product__accordion details"
    );
    detailsElements.forEach(function (detailsElement) {
      detailsElement.addEventListener("toggle", function (event) {
        if (window.innerWidth <= 767 && detailsElement.hasAttribute("open")) {
          event.preventDefault(); // Prevent default behavior
          detailsElement.removeAttribute("open"); // Close the details element
          showModal(detailsElement); // Show modal with content
        }
      });
    });

    // Close modal functionality
    closeModalBtn.addEventListener("click", function () {
      modal.style.display = "none";
      modal.querySelector(".mobile-cart-action").classList.add("hidden");
    });

    window.addEventListener("click", function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    });
  };
});



var DiscountCountdown = class extends HTMLElement {
  constructor() {
    super();
    this._endingTime = this.getAttribute("data-ending_time");
    this._dateEl = this.querySelector(".countdown__item.day>span");
    this._hourEl = this.querySelector(".countdown__item.hour>span");
    this._minuteEl = this.querySelector(".countdown__item.minute>span");
    this._secondsEl = this.querySelector(".countdown__item.seconds>span");
    this._countdownIntervalFunction = this._handleCountdown.bind(this);
  }
  connectedCallback() {
    this._interval = setInterval(this._countdownIntervalFunction, 1000);
  }
  disconnectedCallback() {
    clearInterval(this._interval);
  }
  _formatNumber(num) {
    if(num < 10) {
      return `0${num}`;
    } else {
      return num;
    }
  }
  _handleCountdown() {
    // ??????
    // const targetTime = new Date(this._endingTime).getTime();
    const targetTime = new Date(this._endingTime).getTime()
    // ??????
    const currentTime = new Date().getTime();
    // ?????
    const diffTime = targetTime - currentTime;
    if (diffTime <= 0) {
      // ??
      this._dateEl.html("00");
      this._hourEl.html("00");
      this._minuteEl.html("00");
      this._secondsEl.html("00");
      return;
    }
    // ?????day
    const day = Math.floor(diffTime / 86400000);
    const dayRemain = Math.floor(diffTime % 86400000);
    // ?????
    const hours = Math.floor(dayRemain / 3600000);
    const hoursRemain = Math.floor(dayRemain % 3600000);
    // ?????
    const minutes = Math.floor(hoursRemain / 60000);
    const minutesRemain = Math.floor(hoursRemain % 60000);
    // ????
    const seconds = Math.floor(minutesRemain / 1000);
    // ??
    this._dateEl.innerHTML = this._formatNumber(day);
    this._hourEl.innerHTML = this._formatNumber(hours);
    this._minuteEl.innerHTML = this._formatNumber(minutes);
    this._secondsEl.innerHTML = this._formatNumber(seconds);
  }
};
if (!window.customElements.get("discount-countdown")) {
  window.customElements.define("discount-countdown", DiscountCountdown);
}

/* ANZHAP_SPU_SEARCH_FIX */
(function() {
  function cleanSearchTerm(term) {
    return (term || '')
      .replace(/^variants\.sku:/i, '')
      .replace(/^\s*"(.*)"\s*$/, '$1')
      .replace(/\*$/, '')
      .trim();
  }

  function shouldUseSkuSearch(term) {
    var clean = cleanSearchTerm(term);
    return /^[A-Za-z]+-[A-Za-z0-9-]+$/.test(clean) || /^[A-Z]{2,6}$/.test(clean);
  }

  function normalizedQuery(term) {
    var clean = cleanSearchTerm(term);
    return shouldUseSkuSearch(clean) ? 'variants.sku:' + clean : clean;
  }

  function searchFormUrl(form, query) {
    var params = new URLSearchParams();
    var fields = form.querySelectorAll('input, select, textarea');
    Array.prototype.forEach.call(fields, function(field) {
      if (!field.name || field.disabled || field.name === 'q') return;
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
      params.append(field.name, field.value);
    });
    params.set('type', 'product');
    params.set('options[unavailable_products]', 'show');
    params.set('options[prefix]', 'last');
    params.set('q', query);
    return '/search?' + params.toString();
  }

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action="/search"], form[action$="/search"]')) return;

    var visibleInput = form.querySelector('input[data-search-display]') || form.querySelector('input[type="search"]') || form.querySelector('input[name="q"]');
    if (!visibleInput) return;

    var query = normalizedQuery(visibleInput.value);
    if (query && query !== visibleInput.value.trim()) {
      event.preventDefault();
      window.location.href = searchFormUrl(form, query);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    var params = new URLSearchParams(window.location.search);
    var rawQuery = params.get('q') || '';
    var displayQuery = cleanSearchTerm(rawQuery);
    if (displayQuery && displayQuery === rawQuery && shouldUseSkuSearch(displayQuery) && /\/search\/?$/.test(window.location.pathname)) {
      var noResultText = document.body && /did not yield any results|0 results found/i.test(document.body.textContent || '');
      if (noResultText) {
        window.location.replace(searchFormUrl(document.createElement('form'), normalizedQuery(displayQuery)));
        return;
      }
    }
    if (!displayQuery || displayQuery === rawQuery) return;

    var inputs = document.querySelectorAll('form[action="/search"] input[type="search"], form[action$="/search"] input[type="search"], input[data-search-display]');
    Array.prototype.forEach.call(inputs, function(input) {
      input.value = displayQuery;
    });

    var titles = document.querySelectorAll('.content-main-title h2, .breadcrumb-list span');
    Array.prototype.forEach.call(titles, function(node) {
      node.textContent = node.textContent.replace(rawQuery, displayQuery);
    });

    params.set('q', displayQuery);
    var cleanUrl = window.location.pathname + '?' + params.toString() + window.location.hash;
    window.history.replaceState({}, document.title, cleanUrl);
  });
})();

;(function() {
  if (window.__anzhapSearchSubmitHiddenQFix) return;
  window.__anzhapSearchSubmitHiddenQFix = true;
  function normalizeSkuPrefixSearchTerm(term) {
    var trimmedTerm = String(term || '').trim();
    if (/^variants\.sku:/i.test(trimmedTerm)) return trimmedTerm;
    if (/^[A-Za-z]+-[A-Za-z0-9-]+$/.test(trimmedTerm) || /^[A-Z]{2,6}$/.test(trimmedTerm)) {
      return 'variants.sku:' + trimmedTerm;
    }
    return trimmedTerm;
  }
  function findDisplayInput(form) {
    return form.querySelector('input[data-search-display]') ||
      form.querySelector('input[name="q"]:not([type="hidden"])') ||
      form.querySelector('input[name="q"]');
  }
  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action="/search"], form[action$="/search"]')) return;
    var displayInput = findDisplayInput(form);
    if (!displayInput) return;
    var queryInput = form.querySelector('input[type="hidden"][name="q"]') || displayInput;
    queryInput.value = normalizeSkuPrefixSearchTerm(displayInput.value);
  }, true);
})();
// codex-search-submit-hidden-q-fix
